import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from '@mui/material'
import { DateTimePicker, PickersActionBarAction } from '@mui/x-date-pickers-pro'
import dayjs, { Dayjs } from 'dayjs'
import { FC, useContext, useEffect, useState } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { RepairOrderContext } from '../../../providers/RepairOrderProvider/RepairOrderProvider'
import { useUpdateRepairOrderMutation } from '../../../redux/api'

interface Props {
  open: boolean
  handleClose: () => void
}

const CloseDateDialog: FC<Props> = ({ open, handleClose }) => {
  const { repairOrder } = useContext(RepairOrderContext)
  const { accessToken } = useAccessTokenAndShopId()
  const [updateRepairOrder, { isLoading }] = useUpdateRepairOrderMutation()
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null)

  useEffect(() => {
    if (repairOrder) {
      setSelectedDate(
        repairOrder.entry!.info!.closedOn
          ? dayjs(repairOrder.entry!.info!.closedOn)
          : null
      )
    }
  }, [repairOrder])

  const updateClosedDate = async () => {
    if (selectedDate == null) {
      return
    }
    await updateRepairOrder({
      authorization: accessToken,
      repairOrderEntry: {
        ...repairOrder!.entry!,
        info: {
          ...repairOrder!.entry!.info!,
          closedOn: selectedDate.toDate()
        }
      }
    })
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        Configure Close Date
        <Typography variant="subtitle2">
          Select the closed date for this repair order.{' '}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1} pt={2}>
          <DateTimePicker
            sx={{ width: '20em', alignSelf: 'center' }}
            label="Selected Date"
            value={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            slotProps={{
              actionBar: {
                actions: ['clear'].map(
                  (action) => action as PickersActionBarAction
                )
              }
            }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          disabled={isLoading || selectedDate == null}
          onClick={updateClosedDate}>
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CloseDateDialog
